<template>
  <v-flex xs12>
    <v-card-title>
      <v-btn small @click="openChangelogDialog">View Complete Changelog</v-btn>
      <v-btn v-if="booking.payment_type == 'card'" class="ml-1 white--text" color="green darken-1"  small @click="waitingTimeDialog = true">Reset Waiting Time</v-btn>
    </v-card-title>
    <v-simple-table
      dense
      class="timeline"
      style="font-size: 11px !important;"
    >
      <template v-slot:default>
        <tbody>
          <template
            v-for="(event,index) in eventsForBooking( booking )"
          >
            <tr :key="index+1">
              <td style="width: 20%">
                {{ event.state }}
              </td>
              <td style="width: 40%">
                {{ event.name }}
              </td>
              <td style="width: 30%">
                {{ formatDate(event.date, "DD/MM/YYYY HH:mm ") }}
              </td>
              <td style="width: 10%">
                {{ event.description }}
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
      <v-divider></v-divider>
      <v-card-subtitle>Location Traces</v-card-subtitle>
      <v-divider></v-divider>
    <v-simple-table
        v-if="booking && booking.destination_location_traces && booking.destination_location_traces.length"
      dense
      class="timeline"
      style="font-size: 11px !important;"
    >
      <template v-slot:default>
        <tbody>
         <tr>
             <th>Via Point</th>
             <th>Reach Time</th>
         </tr>
        <tr v-for="destinationTrace in booking.destination_location_traces" :key="destinationTrace.location_id">
            <td>{{destinationTrace.description.substring(0,20)}}</td>
            <td>{{destinationTrace.visited_at}}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-row>
      <v-row justify="center">
        <v-dialog
          v-model="changelogDialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="changelogDialogClosed"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  dark
                  text
                  @click="fetchChangelog"
                >
                  Reload
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-list
              three-line
              subheader
            >
              <v-row>
                <v-col md="12">
                  <BookingChangelog @close="changelogDialogClosed" :booking="booking"></BookingChangelog>
                </v-col>
              </v-row>
       
            </v-list>
            <v-divider></v-divider>
          </v-card>
        </v-dialog>
        <v-dialog v-model="waitingTimeDialog" width="450">
          <AdjustWaitingTimeBox :booking="booking" :user="user" @close = "waitingTimeDialog = false"></AdjustWaitingTimeBox>
        </v-dialog>
      </v-row>
    </v-row>
  </v-flex>
</template>

<script>
import moment from "moment";
import BookingChangelog from '@/components/booking/Changelog'
import {BookingForm} from '@/components/util/BookingForm'
import DateAndTimeInput from '@/components/widget/input/DateAndTimeInput'
import axios from 'axios'
import AdjustWaitingTimeBox from '@/components/booking/AdjustWaitingTimeBox'


class DateTimeWrapper {
  constructor(date, time) {
    this.date = date;
    this.time = time;
  }
  
  setDate(newDate) {
    this.date = newDate;
  }
  
  setTime(newTime) {
    this.time = newTime;
  }
}

export default {
  name: "Timeline",
  components: {AdjustWaitingTimeBox, DateAndTimeInput, BookingChangelog},
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    booking: Object,
    user: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      formData: new DateTimeWrapper(null, null),
      waitingTimeDialog: false,
      changelogDialog: false,
      changelogBooking: null,
    }
  },
  computed: {
    bookingId () {
      return this.booking ? this.booking.id : null
    },
  },
  watch: {
    waitingTimeFormatted(newValue) {
      if (newValue) {
        this.waitingTimeInMinutes = null;
      }
    },
    waitingTimeInMinutes(newValue) {
      if (newValue !== null && newValue !== "") {
        this.waitingTimeDate = null;
        this.waitingTimeTime = null;
      }
    },
  },
    methods: {
    fetchChangelog() {
      if (this.bookingId) {
        this.$store.dispatch('booking/getBookingChangelog', this.bookingId)
      }
    },
    changelogDialogClosed() {
      this.changelogDialog = false
      this.changelogBooking = null
    },
    openChangelogDialog() {
      this.changelogBooking = this.booking
      this.changelogDialog = true
    },
    bookingCancellationReason: function(booking) {
      var reason = "";

      reason += booking.cancellation_type;

      if (booking.cancellation_reason != null) {
        reason += ", " + booking.cancellation_reason;
      }

      if (booking.cancellation_description != null) {
        reason += ", " + booking.cancellation_description;
      }

      return reason;
    },
    eventsForBooking: function(booking) {
      var events = [];

      if (booking.id == null) {
        return [];
      }

      console.log("Events for booking");

      events.push({
        state: 'booked',
        date: moment(booking.created_at, "DD/MM/YYYY HH:mm").toDate(),
        name:
          "Booking Created via " +
          booking.booking_type +
          (booking.booked_by != null
            ? " (Booked by " + booking.booked_by + ")"
            : ""),
        description: null
      });

      if (booking.accept_time != null) {
        events.push({
          state: 'assigned',
          date: moment(booking.accept_time, "DD/MM/YYYY HH:mm").toDate(),
          name:
            "Driver " +
            booking.driver.name +
            " Accepted Trip (dispatched by " +
            (booking.dispatched_by == null
              ? "Auto Dispatch"
              : booking.dispatched_by) +
            ")",
          description: null
        });
      }

/*
      if (booking.asap == false) {
        events.push({
          state: booking.state,
          date: booking.pickup_datetime.toDate(),
          name: "Pickup Time",
          description: null
        });
      }
*/

      if (booking.arrived_time != null) {
        events.push({
          state: 'arrived',
          date: moment(booking.arrived_time, "DD/MM/YYYY HH:mm").toDate(),
          name: "Driver Arrived at pickup",
          description: null
        });
      }

      if (booking.pob_time != null) {
        events.push({
          state: 'pob',
          date: moment(booking.pob_time, "DD/MM/YYYY HH:mm").toDate(),
          name: "Passenger(s) on board",
          description: null
        });
      }

      if (booking.finished_time != null) {
        if (booking.state == "cancelled") {
          events.push({
            state: 'cancelled',
            date: moment(booking.finished_time, "DD/MM/YYYY HH:mm").toDate(),
            name: "Booking Cancelled",
            description: this.bookingCancellationReason(booking)
          });
        } else {
          events.push({
            state: 'completed',
            date: moment(booking.finished_time, "DD/MM/YYYY HH:mm").toDate(),
            name: "Booking Completed",
            description: null
          });
        }
      }

      console.log("Events: " + events.length);

      events.sort(function(a, b) {
        return a.date - b.date;
      });

      return events;
    },
    formatDate: function(e, f) {
      return moment(e).format(f);
    }
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.v-timeline-item {
  padding-bottom: 8px !important;
}

.v-timeline {
  padding-top: 8px !important;
}

tr[role="row"] {
  height: 64px !important;
}

.e-resource-column-wrap tr {
  height: 64px !important;
}

.timeline .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11px !important;
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.line {
  flex-grow: 1;
  height: 1px;
  background-color: #000;
}

.or {
  margin: 0 10px;
}

</style>
